import { LoggingService } from 'src/features/common/services/logging-service';
import { request } from './request';
import { getBrowserName, getOSName } from 'src/helpers/browser';
import { Environment } from 'src/Environment';
import { getCurrentStep, getLoggingTraceId, getParamsFromUrl } from 'src/helpers/logging';
import { getJourneyNameFromSessionStorage } from 'src/utils/SessionStorage/GetJourneyNameFromSessionStorage';

export async function getAddressDetailsFromSearchLocation(
  searchLocation,
  resultCount = 5,
  abortController,
  handleErrorResponse,
  application,
) {
  const loggingService = new LoggingService();

  const mapAddressComponents = (addressComponents) => {
    return addressComponents.reduce((result, addressComponent) => {
      const componentType = addressComponent.administrative_type || addressComponent.type;
      const componentValue = addressComponent.long_name;
      switch (componentType) {
        case 'street_number':
          result.streetNumber = componentValue;
          break;
        case 'route':
          result.street = componentValue;
          break;
        case 'suburb':
        case 'sublocality_level_1':
        case 'sublocality_level_2':
          result.suburb = componentValue;
          break;
        case 'town':
        case 'locality':
          result.city = componentValue;
          break;
        case 'province':
        case 'administrative_area_level_1':
          result.province = componentValue;
          break;
        case 'country':
          result.country = componentValue;
          break;
        case 'post_street':
        case 'postal_street_code':
        case 'postal_code':
          result.postalCode = componentValue;
          break;
        case 'unit':
          result.unit = componentValue;
          break;
        case 'building':
          result.building = componentValue;
          break;
      }
      return result;
    }, {});
  };

  const endpoint = `geocode/address?ilsGroups=address_component&ilsLocation=${searchLocation}&ilsResultCount=${resultCount}`;

  const startTime = performance.now();
  const res = await request(
    endpoint,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    false,
    false,
    false,
  );

  const isAborted = !!abortController && abortController.signal.aborted;

  // only log when application is defined
  // TODO: to be updated when adding logging to the portal
  if (application && !isAborted) {
    loggingService.info({
      traceId: getLoggingTraceId(),
      solutionType: application.solutionType,
      journey: getJourneyNameFromSessionStorage(),
      currentStep: getCurrentStep(application.steps, application.currentStepIndex),
      referenceNumber: application.referenceNumber,
      timestamp: new Date().toISOString(),
      api: {
        responseTime: (performance.now() - startTime).toFixed(),
        statusCode: res.status,
        endpoint: res.url,
        params: getParamsFromUrl(endpoint),
        responseBody: res.result,
      },
      device: {
        platform: getOSName(navigator.userAgent),
        browserName: getBrowserName(navigator.userAgent),
      },
      url: window.location.href,
      environment: Environment.current.env,
    });
  }

  if (res.status === 200) {
    return (res.result?.results || []).map((resultItem, index) => ({
      index: index,
      addressName: resultItem.formatted_address,
      address: mapAddressComponents(resultItem.address_components),
      coordinates: resultItem.geometry.location,
    }));
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse();
  }
}
